/**
 * Stable CSS class names for E2E — ScheduleCreate Settings tab.
 */
export const SCS = {
    root: 'schedule-settings-tab',

    cronRow: 'schedule-settings-tab__cron-row',
    cronLabel: 'schedule-settings-tab__cron-label',
    cronWrap: 'schedule-settings-tab__cron-wrap',

    queueRow: 'schedule-settings-tab__queue-row',
    queueInput: 'schedule-settings-tab-input__queue-name',

    enabledRow: 'schedule-settings-tab__enabled-row',
    enabledSwitch: 'schedule-settings-tab-input__enabled-switch',

    authRow: 'schedule-settings-tab__auth-row',
    authSwitch: 'schedule-settings-tab-input__has-auth-switch',

    timeZoneRow: 'schedule-settings-tab__timezone-row',
    timeZoneSelect: 'schedule-settings-tab-input__timezone-select',
    timeZoneOption: 'schedule-settings-tab-input__timezone-option',

    emailsRow: 'schedule-settings-tab__emails-row',
    emailRow: 'schedule-settings-tab__email-row',
    emailInput: 'schedule-settings-tab-input__email',
    removeEmailButton: 'schedule-settings-tab-input--button-remove-email',
    removeEmailIcon: 'schedule-settings-tab__remove-email-icon',
    addEmailButton: 'schedule-settings-tab-input--button-add-email',
    addEmailIcon: 'schedule-settings-tab__add-email-icon',
    addEmailText: 'schedule-settings-tab__add-email-text',
} as const;

export const scsCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

